import { MODAL_TYPES, ModalType } from "../../constants";
import { InfoLocationModal } from "../modals/InfoLocationModal";

interface InfoLocationModalWrapperProps {
  currentModal: ModalType;
  isModalOpen: (modalType: ModalType) => boolean;
  locationId?: number | null;
  onClose: () => void;
  refreshInterval?: number;
}

export const InfoLocationModalWrapper = ({
  isModalOpen,
  locationId,
  onClose,
  refreshInterval,
}: InfoLocationModalWrapperProps) => {
  return (
    <InfoLocationModal
      show={isModalOpen(MODAL_TYPES.INFO_LOCATION)}
      onHide={onClose}
      locationId={locationId}
      refreshInterval={refreshInterval}
    />
  );
};
